import React from "react";
import { Badge } from "../Badge";
import Tooltip from "components/Tooltip";
import { Icon } from "assets/icons/Icon";
import { formattedDate, formattedSimpleDate } from "utils/dateFormat";
import { isRFQDraft } from "utils/helpers";
const StatusBadge = ({ status, submittedDateTime, rfqStatus }) => {
	let colorStatus = "";
	let statusText = "";
	const statusType = status?.toUpperCase();
	const isDraft = isRFQDraft(rfqStatus);
	switch (statusType) {
		case "ACTIVE":
			colorStatus = "active";
			statusText = "Open";
			break;
		case "COMPLETE":
			colorStatus = "success";
			statusText = "Complete";
			break;
		case "ON_HOLD":
			colorStatus = "default";
			statusText = "On Hold";
			break;
		case "ARCHIVED":
			colorStatus = "default";
			statusText = "Archived";
			break;
		case "CANCELLED":
			colorStatus = "error";
			statusText = "Cancelled";
			break;
		case "SUSPENDED":
			colorStatus = "error";
			statusText = "Suspended";
			break;
		case "PREQUALIFIED": // this is for when draft rfx and user hasn't saved any participants yet (not from BE)
			colorStatus = "default";
			statusText = "Prequalified";
			break;
		case "INVITED":
			colorStatus = isDraft ? "default" : "success";
			statusText = isDraft ? "Prequalified" : "Invited";
			break;
		case "SUBMITTED":
			colorStatus = "active";
			statusText = "Submitted ";
			break;
		case "ACCEPTED":
			colorStatus = "success";
			statusText = "Accepted";
			break;
		case "EVALUATION":
			colorStatus = "success";
			statusText = "Evaluation";
			break;
		case "AWARDED":
			colorStatus = "active";
			statusText = "Awarded";
			break;
		case "DECLINE":
			colorStatus = "error";
			statusText = "Declined";
			break;
		case "INPROGRESS":
			colorStatus = "success";
			statusText = "In Progress";
			break;
		default:
			colorStatus = "default";
			statusText = status;
			break;
	}

	return (
		<div className="flex flex-wrap items-center gap-1">
			<Badge color={colorStatus}>
				<p className="font-roboto text-sm font-medium capitalize leading-5">
					{statusText}
				</p>
			</Badge>
			{statusType === "SUBMITTED" && (
				<div class="submitted-at-tooltip | block w-full text-[12px]">
					<Tooltip
						label={`Submitted on: ${formattedDate(submittedDateTime)}`}
						placement="top-start"
						hasArrow
					>
						<Icon
							icon="calendar"
							color="#0031DD"
							class="aling-middle -mt-[2px] mr-1 inline-block w-[12px]"
						/>
						{formattedSimpleDate(submittedDateTime)}
					</Tooltip>
				</div>
			)}
		</div>
	);
};

export default StatusBadge;
